import { CareersView } from '../views';
export default CareersView;
